var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "查看明细",
            visible: _vm.drawerVisible,
            size: "80%",
            "destroy-on-close": "",
            "before-close": _vm.handleClose,
            "append-to-body": "",
            "custom-class": "evaluateDetailDrawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "evaluate-detail-search", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "评价状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: {
                        multiple: "",
                        placeholder: "全部",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchForm.satisfied,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "satisfied", $$v)
                        },
                        expression: "searchForm.satisfied",
                      },
                    },
                    _vm._l(_vm.searchOptions.satisfied, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "不满意原因" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "280px" },
                      attrs: {
                        multiple: "",
                        placeholder: "全部",
                        "collapse-tags": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.searchForm.tags_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "tags_id", $$v)
                        },
                        expression: "searchForm.tags_id",
                      },
                    },
                    _vm._l(_vm.searchOptions.tags_id, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评价是否有效" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "160px" },
                      attrs: { placeholder: "全部", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.searchOptions.status, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: {
                width: "100%",
                flex: "1",
                overflow: "hidden",
                "overflow-y": "auto",
              },
              attrs: {
                border: "",
                data: _vm.tableList,
                "header-cell-style": {
                  background: "#F1F1F1",
                  color: "#333333",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "基本信息", "min-width": "180", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(_vm._s(scope.row.order_id) + " 商城"),
                        ]),
                        _c("div", { staticClass: "text-blue" }, [
                          _vm._v(_vm._s(scope.row.order_sn)),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(scope.row.order_create_time)),
                        ]),
                        _c("div", [
                          _vm._v(
                            "金额/购买数量：" +
                              _vm._s(scope.row.order_amount) +
                              "/" +
                              _vm._s(scope.row.goods_count)
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "销售订单号：" +
                              _vm._s((scope.row.sale_order_id || []).join("、"))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "用户信息", "min-width": "150", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "text-blue" }, [
                          _vm._v(_vm._s(scope.row.card_no)),
                        ]),
                        _c("div", [_vm._v(_vm._s(scope.row.mobile))]),
                        _c("div", [_vm._v(_vm._s(scope.row.username))]),
                        scope.row.is_vip === 1
                          ? _c("div", { staticClass: "text-danger" }, [
                              _vm._v("VIP"),
                            ])
                          : _vm._e(),
                        _c("div", [
                          _vm._v("反馈渠道：" + _vm._s(scope.row.source_text)),
                        ]),
                        scope.row.source === 3 && scope.row.unionid
                          ? _c("div", { staticClass: "text-danger" }, [
                              _vm._v("UnionId: " + _vm._s(scope.row.unionid)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供应商/状态",
                  "min-width": "110",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.supplier_name))]),
                        _c("div", [
                          _vm._v(_vm._s(scope.row.order_status_text)),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(scope.row.abnormal_status_text)),
                        ]),
                        _c("div", [
                          _vm._v("负责人："),
                          _c("span", { staticClass: "text-blue" }, [
                            _vm._v(_vm._s(scope.row.admin_name)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品信息", "min-width": "220", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.goods_info,
                        function (goods, gIdx) {
                          return _c("div", { key: gIdx }, [
                            _c("span", { staticClass: "text-blue" }, [
                              _vm._v(_vm._s(goods.goods_name)),
                            ]),
                            _vm._v("（"),
                            _c("span", { staticClass: "text-blue" }, [
                              _vm._v(_vm._s(goods.goods_id)),
                            ]),
                            _vm._v("） "),
                            _c("br"),
                            _vm._v(
                              " 发货供应商：" +
                                _vm._s(goods.supplier_name || "-") +
                                " "
                            ),
                          ])
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "调查信息", "min-width": "200", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _vm._v(
                              " 发出时间：" + _vm._s(scope.row.send_time) + " "
                            ),
                            scope.row.is_send_sms === 1
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "right",
                                      trigger: "click",
                                      width: "300",
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(scope.row.order_create_time) +
                                          " 公众号发送"
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(scope.row.send_time) +
                                          " 短信发送"
                                      ),
                                    ]),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "text",
                                          size: "mini",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("更多")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("div", [
                          _vm._v("反馈时间：" + _vm._s(scope.row.submit_time)),
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              " " + _vm._s(scope.row.satisfied_text) + " "
                            ),
                          ]),
                          scope.row.satisfied === 1 || scope.row.satisfied === 2
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " (" + _vm._s(scope.row.tags_name) + ") "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        scope.row.content
                          ? _c("div", [
                              _vm._v("备注：" + _vm._s(scope.row.content)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "跟进信息", "min-width": "220", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.follow && scope.row.follow.length
                          ? [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right",
                                    trigger: "hover",
                                    width: "400",
                                  },
                                },
                                [
                                  _vm._l(
                                    scope.row.follow,
                                    function (item, fIdx) {
                                      return _c(
                                        "div",
                                        {
                                          key: fIdx,
                                          staticClass: "follow-popover-item",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.create_time) +
                                              " " +
                                              _vm._s(item.operator) +
                                              " 处理结果：" +
                                              _vm._s(item.note) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "follow-first-item text-link",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.follow[0].create_time
                                          ) +
                                          " " +
                                          _vm._s(scope.row.follow[0].operator) +
                                          " 处理结果：" +
                                          _vm._s(scope.row.follow[0].note) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                              _vm._l(
                                scope.row.follow.slice(1, 3),
                                function (item, fIdx) {
                                  return _c("div", { key: fIdx + 1 }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.create_time) +
                                        " " +
                                        _vm._s(item.operator) +
                                        " 处理结果：" +
                                        _vm._s(item.note) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "page__style" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [50, 100, 300, 500, 1000],
                  "current-page": _vm.paging.page,
                  "page-size": _vm.paging.page_size,
                  total: _vm.paging.totalCount,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }